import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Scale } from 'lucide-react';
export const ProofSection = () => {
  return <SectionWrapper bg="bg-gold-500" className="text-navy-900" data-id="element-113">
      <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-114">
        <Scale className="w-16 h-16 mb-8 text-navy-900 opacity-80" data-id="element-115" />

        <p className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-8" data-id="element-116">
          "Lo que antes te tomaba años de espera o miles de dólares en abogados,
          ahora se reduce a un ciclo de investigación de 30 días protegido por
          la ley federal estadounidense."
        </p>

        <div className="w-24 h-1 bg-navy-900/20 mx-auto mb-8" data-id="element-117"></div>

        <p className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-118">
          El poder cambia de manos: de los bancos a ti.
        </p>
      </div>
    </SectionWrapper>;
};